import { render, staticRenderFns } from "./TaskCopyPopup.vue?vue&type=template&id=0a2fe43e&scoped=true&lang=pug&"
import script from "./TaskCopyPopup.vue?vue&type=script&lang=js&"
export * from "./TaskCopyPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskCopyPopup.vue?vue&type=style&index=0&id=0a2fe43e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2fe43e",
  null
  
)

export default component.exports